import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { AppConfig } from "./datasources/AppConfig";
import { Settings } from "./datasources/remote_datasource";
import { autenticacaoService } from "./services/autenticacaoService";
import type { Token } from "./datasources/remote_datasource";
import { decryptId } from "./utils/tokenCrypto";

function renderApp() {
  try {
    const root = document.getElementById("root");
    if (!root) {
      return;
    }
    createRoot(root).render(<App />);
  } catch (error) {
    const root = document.getElementById("root");
    if (root) {
      // Seguro: usa DOM API pura em vez de innerHTML para evitar XSS
      const errorText = String(error);
      root.textContent = "";

      const container = document.createElement("div");
      container.style.minHeight = "100vh";
      container.style.display = "flex";
      container.style.alignItems = "center";
      container.style.justifyContent = "center";
      container.style.fontFamily = "Inter, sans-serif";
      container.style.padding = "2rem";

      const inner = document.createElement("div");
      inner.style.textAlign = "center";

      const h1 = document.createElement("h1");
      h1.style.color = "#dc2626";
      h1.textContent = "Erro ao carregar";

      const p1 = document.createElement("p");
      p1.style.color = "#6b7280";
      p1.style.marginTop = "1rem";
      p1.textContent = "Ocorreu um erro ao inicializar a aplicação.";

      const pre = document.createElement("pre");
      pre.style.background = "#f3f4f6";
      pre.style.padding = "1rem";
      pre.style.borderRadius = "8px";
      pre.style.fontSize = "0.75rem";
      pre.style.marginTop = "1rem";
      pre.style.textAlign = "left";
      pre.style.overflow = "auto";
      pre.style.maxWidth = "500px";
      pre.textContent = errorText;

      const btn = document.createElement("button");
      btn.style.marginTop = "1rem";
      btn.style.background = "linear-gradient(135deg, #2d6a4f, #1d4ed8)";
      btn.style.color = "#fff";
      btn.style.border = "none";
      btn.style.padding = "0.75rem 1.5rem";
      btn.style.borderRadius = "8px";
      btn.style.cursor = "pointer";
      btn.textContent = "Recarregar";
      btn.onclick = () => window.location.reload();

      inner.append(h1, p1, pre, btn);
      container.append(inner);
      root.append(container);
    }
  }
}

// Carregar configurações do localStorage antes de iniciar a aplicação
async function loadConfigFromLocalStorage() {
  try {
    const municipioIdCifrado = localStorage.getItem("municipioId");
    const municipioLongCifrado = localStorage.getItem("municipioLong");
    const ouvidoriaIdCifrado = localStorage.getItem("ouvidoriaId");
    const agenteIdCifrado = localStorage.getItem("agenteId");
    const dataExpiracao = localStorage.getItem("dataExpiracao");
    const chaveRecuperacao = localStorage.getItem("chaveRecuperacao");
    const segredoRecuperacao = localStorage.getItem("segredoRecuperacao");

    // Descriptografar IDs
    const [municipioId, municipioLong, ouvidoriaId, agenteId] = await Promise.all([
      municipioIdCifrado ? decryptId(municipioIdCifrado) : Promise.resolve(''),
      municipioLongCifrado ? decryptId(municipioLongCifrado) : Promise.resolve(''),
      ouvidoriaIdCifrado ? decryptId(ouvidoriaIdCifrado) : Promise.resolve(''),
      agenteIdCifrado ? decryptId(agenteIdCifrado) : Promise.resolve(''),
    ]);

    if (municipioId) AppConfig.municipioId = municipioId;
    if (municipioLong) AppConfig.municipioLong = Number(municipioLong);
    if (ouvidoriaId) AppConfig.ouvidoriaId = ouvidoriaId;
    if (agenteId) AppConfig.agenteId = agenteId;
    if (dataExpiracao) AppConfig.dataExpiracao = dataExpiracao;
    if (chaveRecuperacao) AppConfig.chaveRecuperacao = chaveRecuperacao;
    if (segredoRecuperacao) AppConfig.segredoRecuperacao = segredoRecuperacao;

    // Usar o serviço de autenticação para decriptar e carregar o token
    const tokenAcesso = await autenticacaoService.getTokenAcesso();
    if (tokenAcesso) {
      AppConfig.tokenAcesso = tokenAcesso;
      AppConfig.token = { accessToken: tokenAcesso } as Token;
      Settings.token = AppConfig.token;
    }
  } catch (error) {
    // Error loading config from localStorage
  }
}

loadConfigFromLocalStorage().then(() => {
  renderApp();
});
